export enum EstadoSolicitudAcreditacion {
  ENVIADA = 'ENVIADA',
  APROBADA = 'APROBADA',
  FORMALIZADA = 'FORMALIZADA',
  EN_FIRMA = 'EN_FIRMA',
}
